import axios from 'axios'
import { ProfileModel } from '../auth/models/AuthModel'
import { PROFILE_URL } from '../auth/redux/AuthCRUD'

export const fetchProfileInformation = () => {
    return axios.get<ProfileModel>(PROFILE_URL)
}
